import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getFormValues } from 'redux-form';

import { WebcamMirror } from '../webcam-mirror';
import { RecorderTimer } from '../recorder-timer';
import { MicrophoneVolumeLevel } from '../microphone-volume-level';
import { StartCounter } from './start-counter';
import { RECORDER, RECORDER_STATE, STREAM, FORM_NAME, RECORDER_STATES } from '../fields';
import { useCleanUpRecorder, createAndStartRecorder, resumeRecording } from '../recording-step';

export const RecordingBody = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    [RECORDER]: recorder,
    [RECORDER_STATE]: recorderState,
    [STREAM]: stream,
  } = useSelector(getFormValues(FORM_NAME));
  useCleanUpRecorder();

  const bodyMsg =
    recorderState === RECORDER_STATES.PAUSED || recorderState === RECORDER_STATES.WILL_RESUME
      ? t('recording_paused_message')
      : t('recording_message');

  const onRecordingExpired = () => createAndStartRecorder(stream, dispatch);
  const onResumeRecordingExpired = () => resumeRecording(dispatch, recorder);

  const recorderWillResume = recorderState === RECORDER_STATES.WILL_RESUME;

  return (
    <>
      <div>{bodyMsg}</div>
      <RecorderTimer />
      <div className="ct-wrap-video">
        <WebcamMirror />
        {!recorderState && <StartCounter countFrom={3} expired={onRecordingExpired} />}
        {recorderWillResume && <StartCounter countFrom={3} expired={onResumeRecordingExpired} />}
      </div>
      <MicrophoneVolumeLevel />
    </>
  );
};
